function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.76,26.683l-7.23-12.522a1.768,1.768,0,0,0-3.062,0L.24,26.683a1.768,1.768,0,0,0,1.531,2.652H16.23a1.768,1.768,0,0,0,1.531-2.652ZM9,27.3a1.151,1.151,0,1,1,1.151-1.151A1.152,1.152,0,0,1,9,27.3Zm1.158-4.918a1.158,1.158,0,1,1-2.317,0V17.062a.549.549,0,0,1,.549-.549H9.61a.549.549,0,0,1,.549.549v5.317Z",
  transform: "translate(0 -13.277)"
});

var SvgAttentionYellow = function SvgAttentionYellow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16.057,
    viewBox: "0 0 18 16.057",
    fill: "#f8b131",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAttentionYellow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/attention-yellow.5fd4cf67.svg";
export { ForwardRef as ReactComponent };